module.exports = __webpack_public_path__ + "static/img/rank_271.10e324a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_271.png
// module id = Qjx+
// module chunks = 1